var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictogramPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47,
    height: 43,
    viewBox: "0 0 47 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M0 42.84h46.62V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    opacity: 0.3,
    d: "M6.664.203h15.558L19.2 7.047H1.4zM45.22 7.047H28.324l-2.672-5.663H40.32z",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    d: "M2.573 6.214l.075.184H18.52l2.446-5.014H7.45l-4.876 4.83zm17.455.184h6.566l-2.446-5.014h-1.674l-2.446 5.014zm8.07 0h15.873l.075-.184-4.876-4.83h-13.52L28.1 6.398zm-8.782 1.44c-.032.058-.065.104-.1.14l-.03.03v5.06h8.244V8.01l-.03-.03c-.035-.036-.067-.082-.1-.14l-.03-.056H19.35l-.032.056zM1.4 41.462H45.22V7.782H28.556v5.71l-.013.068-.001.01.001.01c.002.02.008.038.01.048.002.22-.158.36-.25.425-.108.087-.204.13-.298.132-.012-.004-.026-.008-.043-.01h-.016c-.016.001-.03.005-.044.008l-9.18.002c-.018-.005-.033-.01-.048-.01h-.016c-.018.002-.033.006-.043.01-.094-.003-.2-.044-.3-.126-.17-.118-.26-.27-.26-.434a.11.11 0 0 0 .013-.045l.001-.01-.001-.01c-.001-.018-.005-.034-.01-.05l-.004-5.73H1.4v33.68zM.7 42.84c-.385 0-.7-.308-.7-.69V7.092c.003-.004.008-.02.01-.04a.68.68 0 0 1 .039-.191l.01-.026.01-.027c.04-.088.083-.154.137-.207L6.664.203A.7.7 0 0 1 7.159 0h32.303c.186 0 .362.072.494.203l6.46 6.398c.053.053.096.118.136.206.005.01.008.02.01.03l.01.026c.02.06.034.123.038.188a.26.26 0 0 0 .009.047V42.15c0 .38-.313.69-.7.69H.7z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    d: "M36.54 37.8h1.26v-1.26h-1.26v1.26zm1.9 1.26H35.9a.63.63 0 0 1-.63-.63V35.9a.63.63 0 0 1 .63-.63h2.52a.63.63 0 0 1 .631.63v2.52a.63.63 0 0 1-.631.63zm3.14-1.26h1.26v-1.26h-1.26v1.26zm1.9 1.26h-2.52a.63.63 0 0 1-.63-.63V35.9a.63.63 0 0 1 .63-.63h2.52a.63.63 0 0 1 .631.63v2.52a.63.63 0 0 1-.631.63zM20.6 35.9H3.98c-.46 0-.83-.282-.83-.63s.37-.63.83-.63h16.6c.458 0 .83.282.83.63s-.37.63-.83.63m-8.82 3.16h-8.4c-.465 0-.84-.282-.84-.63s.375-.63.84-.63h8.4c.464 0 .84.282.84.63s-.376.63-.84.63",
    mask: "url(#B)",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramPackage);
export default __webpack_public_path__ + "static/media/pictogram-package.180e9c9f882a4a2ba185c84c6804abfa.svg";
export { ForwardRef as ReactComponent };